import { render, staticRenderFns } from "./InstructionalMomentForm.vue?vue&type=template&id=7d886518&scoped=true"
import script from "./InstructionalMomentForm.vue?vue&type=script&lang=js"
export * from "./InstructionalMomentForm.vue?vue&type=script&lang=js"
import style0 from "./InstructionalMomentForm.vue?vue&type=style&index=0&id=7d886518&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d886518",
  null
  
)

export default component.exports